import { createContext } from "react";

export interface AudioPlayerContextValue {
  sources: readonly AudioPlayerSource[];
  registerSourcesProvider: () => AudioPlayerSourcesProviderRegistration;

  currentSourceKey: string | undefined;
  /** Whether playback or seeking has explicitly positioned the playhead. */
  hasRequestedPosition: boolean;
  play: (sourceKey: string, time?: number) => void;
  seek: (sourceKey: string, time?: number) => void;

  nativeAudio: HTMLAudioElement | null;
}

export interface AudioPlayerSourcesProviderRegistration {
  onSourcesChange: (sources: readonly AudioPlayerSource[]) => void;
  unregister: () => void;
}

export interface AudioPlayerSource {
  key: string;
  title: string;
  subtitle: string;
  sortTimestamp: number;
  fragmentTimes?: readonly number[];
  src: string | undefined;
  isLoading?: boolean;
  load?: () => {};
}

export const AudioPlayerContext = createContext<AudioPlayerContextValue>({
  sources: [],
  registerSourcesProvider: () => ({
    onSourcesChange: () => {},
    unregister: () => {},
  }),

  currentSourceKey: undefined,
  hasRequestedPosition: false,
  play: () => {},
  seek: () => {},

  nativeAudio: null,
});
